// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@sc/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Arimo:wght@400..700&display=swap",
    weight: {
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    fontFamily: "'Arimo', 'Lato', sans-serif",
};

export default {
    fontFamilyImportUrl: fontConfig.url,
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        css: css`
            line-height: 26px;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        `,
    },
    p: {
        size: "14px",
        weight: fontConfig.weight.regular,
        css: css`
            margin-bottom: 15px;
            letter-spacing: 0;
            line-height: 22px;
            display: block;
        `,
    },
    h1: {
        size: "28px",
        weight: fontConfig.weight.bold,
        lineHeight: "38px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h2: {
        size: "24px",
        weight: fontConfig.weight.bold,
        lineHeight: "32px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h3: {
        size: "20px",
        weight: fontConfig.weight.bold,
        lineHeight: "28px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h4: {
        size: "18px",
        weight: fontConfig.weight.bold,
        lineHeight: "24px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h5: {
        size: "16px",
        weight: fontConfig.weight.bold,
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h6: {
        size: "14px",
        weight: fontConfig.weight.bold,
        lineHeight: "19px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "18px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "18px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
    },
    headerTertiary: {
        forwardAs: "p",
        size: "18px",
        weight: fontConfig.weight.semiBold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "12px",
        color: "text.accent",
        transform: "uppercase",
        weight: fontConfig.weight.semiBold,
    },
} as xBaseTheme["typography"];
